export const getLoadingUpdateTrafficStatus = (state) => state.adminUser.loadingUpdateTrafficStatus;
